export const getCandidateInfoFields = (t) => [
  {
    sno: "1",
    label: t("Email ID"),
    name: "emailId",
    value: "william@gmail.com",
  },
  {
    sno: "2",
    label: t("Application Submitted"),
    name: "createdAt",
    value: "03rd Aug, 2023",
  },
  { sno: "3", label: t("Phone number"), name: "phoneNo", value: "9876543210" },
  {
    sno: "4",
    label: t("Address"),
    name: "address",
    value: "12,St. Thomas Church opposite,Chennai",
  },
  { sno: "5", label: t("City"), name: "city", value: "Trichy" },
  { sno: "6", label: t("Country"), name: "country", value: "India" },
];
